import {
  Dialog,
  AppBar,
  IconButton,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import {FormattedMessage, useIntl} from "react-intl";
import { TransitionProps } from "@material-ui/core/transitions";
import Slide from "@material-ui/core/Slide";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import ReactToPrint from "react-to-print";
import {ICorrespondence} from "../../interfaces/Correspondence";
import {mapCorrespondenceReceivedToExcel, mapTrackingOfReceivedCorrespondenceToExcel} from "../../helpers/excelMappers";
import {useSelector} from "react-redux";
import {AppState} from "../../redux/reducers/rootReducer";
import {IParamResponseTime} from "../../redux/types/types";

const pageStyle = `
  @media all {
    .page-break {
      display: none;
    }
  }
  
  @media print {
    html, body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  
  @media print {
    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }
  
  @page {
    size: auto;
    margin: 20mm;
  }
  `;

interface ConfirmationDialogProps {
  width?: boolean;
  textButton?: string;
  open: boolean;
  title: string;
  content: any;
  loadingDownload?: boolean;
  onDeny: () => void;
  onConfirm?: () => void;
  titlePDF?: string;
  componentRef?: React.MutableRefObject<HTMLDivElement>;
  excelData?: ICorrespondence[];
  paramResponseTime?: IParamResponseTime;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: "relative",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    btnLoading: {
      color: theme.palette.common.white,
      height: "25px !important",
      width: "25px !important",
    },
  })
);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const CustomizedDialogPDF = (props: ConfirmationDialogProps) => {
  const intl = useIntl();
  const classes = useStyles();
  const { productionOffices } = useSelector((state: AppState) => state.trd);

  const handleExportCorrespondenceToExcel = async () => {
    const { paramResponseTime, excelData = [] } = props;

    if (paramResponseTime) {
      await mapTrackingOfReceivedCorrespondenceToExcel(excelData, intl, productionOffices, paramResponseTime);
    } else {
      await mapCorrespondenceReceivedToExcel(excelData, intl, productionOffices);
    }
  };

  const {
    open,
    title,
    content,
    onDeny,
    onConfirm,
    textButton,
    loadingDownload,
    titlePDF,
    componentRef
  } = props;
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onDeny}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="close"
            onClick={onDeny}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>


              <Button
                  autoFocus
                  color="inherit"
                  onClick={handleExportCorrespondenceToExcel}
                  style={{ marginRight: "1rem" }}
              >
                <FormattedMessage id={`${textButton}`} /> <FormattedMessage id="EXCEL" />
              </Button>



          {textButton &&
            !loadingDownload &&
            (textButton === "Download" && componentRef ? (
              <ReactToPrint
                trigger={() => (
                  <Button autoFocus color="inherit">
                    <FormattedMessage id={`${textButton}`} />
                  </Button>
                )}
                content={() => componentRef.current}
                pageStyle={pageStyle}
                documentTitle={titlePDF}
              />
            ) : (
              <Button autoFocus color="inherit" onClick={onConfirm}>
                <FormattedMessage id={`${textButton}`} /> <FormattedMessage id="PDF" />
              </Button>
            ))}
          {loadingDownload && (
            <Button color="inherit" autoFocus type="button" disabled={true}>
              <CircularProgress className={classes.btnLoading} />
            </Button>
          )}
        </Toolbar>
      </AppBar>
      {content}
    </Dialog>
  );
};
